import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "duels:sound"

export default class extends Controller {
  static targets = ["on", "off"]

  connect() {
    this.render()
  }

  toggle() {
    localStorage.setItem(STORAGE_KEY, this.enabled ? "off" : "on")
    this.render()
  }

  render() {
    const on = this.enabled
    if (this.hasOnTarget) this.onTarget.classList.toggle("hidden", !on)
    if (this.hasOffTarget) this.offTarget.classList.toggle("hidden", on)
  }

  get enabled() {
    return localStorage.getItem(STORAGE_KEY) === "on"
  }
}
